import { render, staticRenderFns } from "./open-app.vue?vue&type=template&id=d80f87b8&scoped=true&"
import script from "./open-app.vue?vue&type=script&lang=js&"
export * from "./open-app.vue?vue&type=script&lang=js&"
import style0 from "./open-app.vue?vue&type=style&index=0&id=d80f87b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80f87b8",
  null
  
)

export default component.exports